import React from "react";
import { Link } from "react-router-dom";
import Image from "../../../assets/images/NC_technologies.jpg";

const Logo = () => {
  return (
    <Link
      to="/"
      className="text-3xl font-bold flex items-center justify-center mb-4"
    >
      <img src={Image} alt="Kokhav Investment Club" className="h-12 w-12" />
    </Link>
  );
};

export default Logo;
